if (!customElements.get('countdown-timer')) {
  function createObserver(options) {
    const threshold = options.threshold ? options.threshold : 0;
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: `0px 0px ${threshold}px 0px`});
    observer.observe(options.element);
  }
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.date = new Date(`${this.dataset.month}/${this.dataset.day}/${this.dataset.year} ${this.dataset.hour}:${this.dataset.minute}:00`);
        this.template = this.querySelector('template').content.firstElementChild.innerHTML;
      }

      connectedCallback() {
        createObserver({
          element: this,
          callback: this.init.bind(this),
          threshold: 200
        });
      }

      init() {
        this.calculate();
        this.timerInterval = setInterval(this.calculate.bind(this), 1000);
      }

      calculate() {
        const now = new Date(),
          countTo = new Date(this.date),
          timeDifference = (countTo - now);

        if (timeDifference < 0) {
          this.complete();
          return;
        }

        let content = this.template;

        const secondsInADay = 60 * 60 * 1000 * 24,
          secondsInAHour = 60 * 60 * 1000;
        const days = Math.floor(timeDifference / (secondsInADay) * 1);
        const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
        const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
        const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
        const days_text = days === 1 ?  window.countdownTimer.day :  window.countdownTimer.days;
        const hours_text = hours === 1 ?  window.countdownTimer.hour :  window.countdownTimer.hours;
        const mins_text = mins === 1 ?  window.countdownTimer.minute :  window.countdownTimer.minutes;
        const secs_text = secs === 1 ?  window.countdownTimer.second :  window.countdownTimer.seconds;

        content = content.replaceAll('[days]', days);
        content = content.replaceAll('[hours]', hours);
        content = content.replaceAll('[mins]', mins);
        content = content.replaceAll('[secs]', secs);
        content = content.replaceAll('[days_text]', days_text);
        content = content.replaceAll('[hours_text]', hours_text);
        content = content.replaceAll('[mins_text]', mins_text);
        content = content.replaceAll('[secs_text]', secs_text);

        const html = new DOMParser().parseFromString(content, 'text/html');
        this.innerHTML = html.body.innerHTML;
      }

      complete() {
        if (this.timerInterval) clearInterval(this.timerInterval);
        this.innerHTML = this.getAttribute('data-countdown-timer-ended-text');
      }
    }
  );
}